<template>
    <div class="signDialog Illegal-unload-container" v-loading="loading">
        <div class="left-box">
            <receipt-upload
                ref="receiptUpload"
                :attachmentList="attachmentList"
                :rowData="rowData"
                @delete-success="deleteReceiptImageSuccess"
                @upload-success="uploadReceiptImageSuccess"
            ></receipt-upload>
        </div>
        <div class="right-box">
            <el-form
                ref="IllegalUnloadForm"
                :model="IllegalUnloadForm"
                :rules="rules"
                label-width="100px"
                class="Illegal-unload-form"
            >
                <el-form-item label="违规卸货：" prop="isIllegalUnload" class="Illegal-unload-formItem">
                    <el-select v-model="IllegalUnloadForm.isIllegalUnload" placeholder="请选择">
                        <el-option label="是" value="Y"></el-option>
                        <el-option label="否" value="N"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input
                        type="textarea"
                        maxlength="250"
                        v-model.trim="IllegalUnloadForm.remark"
                        :rows="10"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import ReceiptUpload from './receiptUpload.vue';
import { getAttachmentDetail } from '@/modules/transport/otp/api/performanceReceiptSign.js';
export default {
    name: 'IllegalUnload',
    components: { ReceiptUpload },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            attachmentList: [], // 附件列表
            loading: false,
            IllegalUnloadForm: {
                isIllegalUnload: '',
                remark: ''
            },
            rules: {
                isIllegalUnload: [{ required: true, message: '请选择是否违规卸货', trigger: 'blur' }]
            }
        };
    },
    mounted () {
        this.initIllegalUnload();
        this.initForm();
    },
    methods: {
        initIllegalUnload () {
            this.loading = true;
            const param = {
                objId: this.rowData.id, // objId 当前签收列表数据id
                objType: 'ILLEGAL_UNLOAD' // 签收类型 固定传ILLEGAL_UNLOAD
            };
            getAttachmentDetail(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.attachmentList = res.data || [];
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.$refs.receiptUpload.show();
                });
        },
        initForm () {
            this.IllegalUnloadForm.remark = this.rowData.remark;
            this.IllegalUnloadForm.isIllegalUnload = this.rowData.isIllegalUnload;
        },
        /**
         * @description 图片上传成功回调
         */
        uploadReceiptImageSuccess () {
            this.initIllegalUnload();
        },
        /**
         * @description 删除图片成功回调
         */
        deleteReceiptImageSuccess () {
            this.initIllegalUnload();
        }
    }
};
</script>
<style lang="less">
    .Illegal-unload-container {
        display: flex;
        .left-box {
            width: 45%;
            margin-left: 8%;
            min-height: 550px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .right-box {
            width: 40%;
            min-height: 550px;
            display: flex;
            align-items: center;
            .Illegal-unload-form {
                width: 65%;
                .el-form-item__label {
                    font-size: 14px;
                }
                .Illegal-unload-formItem {
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>
